import React, { Fragment } from 'react';
import { api } from '../api';
import { Button, Form, Modal } from 'react-bootstrap';

class UserCreator extends React.Component {
    constructor() {
        super();

        this.state = {
            userName: "",
        };
    }

    async createUser(event) {
        event.preventDefault();
        await api.updateMe({ name: this.state.userName });
    }

    async updateUserName(event) {
        event.preventDefault();
        this.setState({ userName: event.target.value });
    }

    render() {
        return (
            <Fragment>
                <div style={{ padding: "24px 12px 24px 12px", marginTop: "100px", marginBottom: "100px" }}>
                    <h1>Create User</h1>
                    <Form
                        noValidate
                        onSubmit={e => this.createUser(e)}>
                        <Form.Group>
                            <Form.Control style={{ width: "353px", float: "left" }} type="text" placeholder="User Name" onChange={e => this.updateUserName(e)}/>
                            <Button variant="primary" type="submit" style={{ float: "right"}}>
                                Create
                            </Button>
                        </Form.Group>
                    </Form>
                </div>
            </Fragment>
        );
    }
}

class UserEditor extends React.Component {
    constructor(props) {
        super();

        this.state = {
            newUserDisplayName: props.currentUserName,
            showUserEditor: false
        };
    }

    async editUser(event) {
        event.preventDefault();
        if(this.props.currentUserName !== this.state.newUserDisplayName) {
            await api.updateMe({ name: this.state.newUserDisplayName });
        }
        this.setState({ showUserEditor: false });
        this.props.onEditCompleted(this.state.newUserDisplayName);
    }

    async updateUserName(event) {
        event.preventDefault();
        this.setState({ newUserDisplayName: event.target.value });
    }

    async onEditNameButtonClicked(event) {
        event.preventDefault();
        this.setState({ showUserEditor: true });
    }

    handleEditUserModalClosed() {
        this.setState({ showUserEditor: false });
    }

    render() {
        return (
            <div style={{display: "inline-block"}}>
                <Button style={{display: "inline-block", verticalAlign: "text-bottom", marginLeft: "6px"}} onClick={this.onEditNameButtonClicked.bind(this)}>Edit Name</Button>
                <Modal show={this.state.showUserEditor} onHide={this.handleEditUserModalClosed.bind(this)}>
                    <Modal.Header closeButton>
                    </Modal.Header>
                    <Modal.Body>
                        <div style={{ padding: "24px 12px 24px 12px", marginBottom: "100px" }}>
                            <h1>Edit User</h1>
                            <Form
                                noValidate
                                onSubmit={e => this.editUser(e)}>
                                <Form.Group>
                                    <Form.Control style={{ width: "353px" }} type="text" value={this.state.newUserDisplayName} onChange={e => this.updateUserName(e)}/>
                                    <br></br>
                                    <Button variant="primary" type="submit" style={{ float: "right", marginLeft: "6px"}}>
                                        Save
                                    </Button>
                                    <Button variant="secondary" style={{ float: "right"}} onClick={this.handleEditUserModalClosed.bind(this)}>
                                        Cancel
                                    </Button>
                                </Form.Group>
                            </Form>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

export { UserCreator, UserEditor };
